function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "capa_ig",
  "data-name": "capa_ig"
}, React.createElement("g", {
  id: "capa_ig-2",
  "data-name": "capa_ig 1"
}, React.createElement("g", {
  id: "Instagram_Circle",
  "data-name": "Instagram Circle"
}, React.createElement("path", {
  className: "cls-ig",
  d: "M26.53,0A26.53,26.53,0,1,0,53.05,26.53,26.53,26.53,0,0,0,26.53,0Zm0,50.64A24.12,24.12,0,1,1,50.64,26.53,24.11,24.11,0,0,1,26.53,50.64Zm7.23-36.17H19.29a4.82,4.82,0,0,0-4.82,4.82V33.76a4.82,4.82,0,0,0,4.82,4.82H33.76a4.82,4.82,0,0,0,4.82-4.82V19.29A4.82,4.82,0,0,0,33.76,14.47Zm-2.41,3.62H35V21.7H31.35ZM26.53,21.7a4.83,4.83,0,1,1-4.83,4.83A4.82,4.82,0,0,1,26.53,21.7Zm9.64,12.06a2.41,2.41,0,0,1-2.41,2.41H19.29a2.41,2.41,0,0,1-2.41-2.41V25.32h2.53a8,8,0,0,0-.12,1.21,7.24,7.24,0,0,0,14.47,0,6.89,6.89,0,0,0-.12-1.21h2.53Z"
}))));

var SvgCellfinateIconoInstagram = function SvgCellfinateIconoInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 53.05 53.05",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCellfinateIconoInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cellfinate_icono_instagram.88954770.svg";
export { ForwardRef as ReactComponent };